import formatUsd from 'format-usd';



function dollars(value, { trimZeros } = {}) {
  let result = value || value === 0
    ? formatUsd({ amount: value })
    : '$0.00';

  if (trimZeros) {
    result = result.replace('.00', '');
  }

  return result;
}



export default dollars;
